import React, {useEffect, useState} from "react";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";
import {useSelector} from "react-redux";
import {
    setFixedAssetSoldReportRequestData, setFixedAssetSoldReportResponseData
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment";
import ReportsTemplate from "../../../common/ReportsTemplate";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import Input from "../../../common/Input";
import Pagination from "../../../primer/Pagination";
import {getGreekCurrencyFormat, hookCompanyLogo, isEmpty} from "../../../../_helpers/commonFunctions";
import BootstrapDropdown from "react-bootstrap/esm/Dropdown";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import * as XLSX from "xlsx";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";

const ReportSoldFixedAssets = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);

    const requestData = useSelector((state) => state.FIXED_ASSETS.fixedAssetSoldReportRequestData[tabKey]);
    const responseData = useSelector((state) => state.FIXED_ASSETS.fixedAssetSoldReportResponseData[tabKey]);
    const setRequestData = (data) => dispatch(setFixedAssetSoldReportRequestData(data));
    const setResponseData = (data) => dispatch(setFixedAssetSoldReportResponseData(data));

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);

    useEffect(() => {
        if (isEmpty(requestData.date_from) && isEmpty(requestData.date_to)) {
            setRequestData({
                ...requestData,
                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
            })
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            setRequestData(reqData);
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-sold`, {
            headers: { "Content-Type": "application/json" },
            params: {
                ...reqData,
                company: company.id,
                year: company.year,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (!fromPagination) toast.success("Επιτυχής ανανέωση δεδομένων.", {autoClose: 1000});
                setResponseData({...responseData, data: res.data.data, totalPages: res.data.totalPages, totals: res.data.totals});
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        setRequestData({...requestData, ...prepChange});
    }

    const dataCollectForExport = async () => {
        let totalData = [];
        try {
            const resp = await axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-sold`, {
                headers: { "Content-Type": "application/json" },
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                    year: company.year,
                }
            });
            if (resp.data.status === "200") {
                totalData = resp.data.data;
            }
        } catch (err) {
            console.log(err);
        }
        return totalData;
    }

    const handlePageChange = (page) => {
        setRequestData({...requestData, page: page});
        setPageChanged(true);
    }

    const handleExcelExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
            rows.push(["Επωνυμία:", company.name]);
            rows.push(["ΑΦΜ:", company.vatNumber]);
            rows.push(["Ημερομηνία Εξαγωγής:", dateExported]);
            rows.push([]);
            rows.push([
                "Αρ.",
                "Κωδ. Συστήματος / Χειρ. Κωδικός",
                "Περιγραφή Παγίου",
                "Ημερομήνια Κτήσης",
                "Ημερομηνία Πώλησης",
                "Αξία Πώλησης",
                "Φ.Π.Α. Πώλησης",
                "Αξία Κτήσης",
                "Φ.Π.Α. Αγοράς",
                "Αποσβέσεις",
                "Λογιστικό Αποτέλεσμα"
            ])
            for (const row of totalData) {
                rows.push([
                    row.no,
                    row.mixedCode,
                    row.name,
                    row.dateBought,
                    row.dateSold,
                    +row.priceSold,
                    +row.vatSold,
                    +row.priceBought,
                    +row.vatBought,
                    +row.accumulatedDepreciation,
                    +row.profit,
                ]);
            }
            const totalSold = +Number(totalData.reduce((sum, item) => sum + (item.priceSold || 0), 0)).toFixed(2);
            const vatSold = +Number(totalData.reduce((sum, item) => sum + (item.vatSold || 0), 0)).toFixed(2);
            const totalBought = +Number(totalData.reduce((sum, item) => sum + (item.priceBought || 0), 0)).toFixed(2);
            const vatBought = +Number(totalData.reduce((sum, item) => sum + (item.vatBought || 0), 0)).toFixed(2);
            const totalAccDep = +Number(totalData.reduce((sum, item) => sum + (item.accumulatedDepreciation || 0), 0)).toFixed(2);
            const totalProfit = +Number(totalData.reduce((sum, item) => sum + (item.profit || 0), 0)).toFixed(2);
            rows.push([
                "", "", "", "", "ΣΥΝΟΛΑ",
                +totalSold,
                +vatSold,
                +totalBought,
                +vatBought,
                +totalAccDep,
                +totalProfit,
            ])
            const workSheet = XLSX.utils.aoa_to_sheet(rows);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "Πωληθέντα Πάγια");
            XLSX.writeFile(workBook, "Πωληθέντα Πάγια.xlsx");
        }
        setLoadingPrint(false);
    }

    const handlePDFExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            const columns = [
                "Αρ.",
                "Κωδ. Συστήματος / Χειρ. Κωδικός",
                "Περιγραφή Παγίου",
                "Ημερομήνια Κτήσης",
                "Ημερομηνία Πώλησης",
                "Αξία Πώλησης",
                "Φ.Π.Α. Πώλησης",
                "Αξία Κτήσης",
                "Φ.Π.Α. Αγοράς",
                "Αποσβέσεις",
                "Λογιστικό Αποτέλεσμα"
            ]
            for (const row of totalData) {
                rows.push([
                    row.no,
                    row.mixedCode,
                    row.name,
                    row.dateBought,
                    row.dateSold,
                    getGreekCurrencyFormat(row.priceSold),
                    getGreekCurrencyFormat(row.vatSold),
                    getGreekCurrencyFormat(row.priceBought),
                    getGreekCurrencyFormat(row.vatBought),
                    getGreekCurrencyFormat(row.accumulatedDepreciation),
                    getGreekCurrencyFormat(row.profit),
                ]);
            }
            const totalSold = +Number(totalData.reduce((sum, item) => sum + (item.priceSold || 0), 0)).toFixed(2);
            const vatSold = +Number(totalData.reduce((sum, item) => sum + (item.vatSold || 0), 0)).toFixed(2);
            const totalBought = +Number(totalData.reduce((sum, item) => sum + (item.priceBought || 0), 0)).toFixed(2);
            const vatBought = +Number(totalData.reduce((sum, item) => sum + (item.vatBought || 0), 0)).toFixed(2);
            const totalAccDep = +Number(totalData.reduce((sum, item) => sum + (item.accumulatedDepreciation || 0), 0)).toFixed(2);
            const totalProfit = +Number(totalData.reduce((sum, item) => sum + (item.profit || 0), 0)).toFixed(2);
            rows.push([
                {content: "Σύνολα", colSpan: 5, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalSold), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(vatSold), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalBought), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(vatBought), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalAccDep), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalProfit), colSpan: 1, styles: {fillColor: "#decae3"}},
            ])
            const doc = new jsPDF('landscape');
            let y = 20;

            doc.addFileToVFS("arialuni.ttf", liberationSerif);
            doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
            doc.addFileToVFS("dejavusans.ttf", dejavuSans);
            doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
            doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
            doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

            hookCompanyLogo(doc, companyDetails);

            const imgData = 'assets/images/prrimer-logo.png';
            const primerWidth = 28;
            const primerHeight = 10;
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
            doc.setFont("DejaVu Sans Bold");
            doc.setFontSize(12);
            const header = doc.splitTextToSize(`Πωληθέντα Πάγια`, 200);
            const headerString = header.join("\n");
            doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
            doc.setFont("DejaVu Sans Normal");

            autoTable(doc, {
                startY: y,
                head: [columns],
                body: rows,
                rowPageBreak: "avoid",
                styles: {
                    font: "DejaVu Sans Normal",
                    fontStyle: "normal",
                    fontSize: 8,
                    halign: "center",
                },
            })
            const pageCount = doc.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(10);
                doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
            }
            doc.save("Πωληθέντα Πάγια.pdf");
        }
        setLoadingPrint(false);
    }

    return (
        <div>
            <ReportsTemplate
                templateType={"report-sold-fixed-assets"}
                requestData={requestData}
                fetchReport={() => fetchReport()}
                setRequestData={(data) => setRequestData(data)} header={"Πωληθέντα Πάγια"}
            />

            <div onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => setRequestData({...requestData, date_from: from, date_to: to})}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_from"
                            selected={requestData.date_from !== "" ? moment(requestData.date_from, "DD-MM-YYYY").toDate() : ""}
                            label={"Ημερομηνία πώλησης από"}
                            onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_to"
                            selected={requestData.date_to !== "" ? moment(requestData.date_to, "DD-MM-YYYY").toDate() : ""}
                            label={"Ημερομηνία πώλησης μέχρι"}
                            onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={6}>
                        <Input
                            label={"Όνομα/Κωδικός παγίου"}
                            name={"generalFilter"}
                            value={requestData.generalFilter}
                            onChange={(e) => handleOnChange(e, "input", "generalFilter")}
                        />
                    </Col>
                </Row>
                <Row className={"d-flex"}>
                    <Col md={2}>
                        <Input
                            label={"Αξία κτήσης από"}
                            type={"number"}
                            name={"acquisitionCost_from"}
                            value={requestData.acquisitionCost_from}
                            onChange={(e) => handleOnChange(e, "input", "acquisitionCost_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            label={"Αξία κτήσης έως"}
                            type={"number"}
                            name={"acquisitionCost_to"}
                            value={requestData.acquisitionCost_to}
                            onChange={(e) => handleOnChange(e, "input", "acquisitionCost_to")}
                        />
                    </Col>
                    <Col md={8} className={"d-flex justify-content-end"}>
                        <Button style={{marginTop: "23px"}} onClick={() => fetchReport(false)} disabled={loading}>
                            Εφαρμογή Φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
            </div>
            {responseData.data.length > 0 && (
                <React.Fragment>
                    <hr/>
                    <Row>
                        <Col md={12} className={"d-flex justify-content-end"}>
                            <Pagination
                                currentPage={requestData.page}
                                totalPages={responseData.totalPages}
                                handlePageChange={(page) => handlePageChange(page)}
                            />
                        </Col>
                    </Row>

                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableGrayHover"}>
                                <thead>
                                <tr>
                                    <th>Α.Α.</th>
                                    <th>Κωδικός Παγίου</th>
                                    <th>Περιγραφή Παγίου</th>
                                    <th>Ημερομήνια Κτήσης</th>
                                    <th>Ημερομηνία Πώλησης</th>
                                    <th>Αξία Πώλησης</th>
                                    <th>Φ.Π.Α. Πώλησης</th>
                                    <th>Αξία Κτήσης</th>
                                    <th>Φ.Π.Α. Αγοράς</th>
                                    <th>Αποσβέσεις</th>
                                    <th>Λογιστικό Αποτέλεσμα</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((row, idx) => (
                                    <tr key={`rsfa${idx}`}>
                                        <td>{row.no}</td>
                                        <td>{row.mixedCode}</td>
                                        <td>{row.name}</td>
                                        <td>{row.dateBought}</td>
                                        <td>{row.dateSold}</td>
                                        <td>{getGreekCurrencyFormat(row.priceSold)}</td>
                                        <td>{getGreekCurrencyFormat(row.vatSold)}</td>
                                        <td>{getGreekCurrencyFormat(row.priceBought)}</td>
                                        <td>{getGreekCurrencyFormat(row.vatBought)}</td>
                                        <td>{getGreekCurrencyFormat(row.accumulatedDepreciation)}</td>
                                        <td style={{
                                            backgroundColor: row.profit > 0 ? "#91ff99" : "#ff9391",
                                            fontWeight: "600"
                                        }}>
                                            {getGreekCurrencyFormat(row.profit)}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={7}>
                            <BootstrapDropdown className="mb-3 mt-3">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic" disabled={loadingPrint}>
                                    Αποθήκευση αποτελεσμάτων {loadingPrint && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Col>
                        <Col md={5}>
                            <div className={"text-muted mb-1"}><i>Σύνολα</i></div>
                            <table className={"simpleClassicTable mb-3"}>
                                <tbody>
                                <tr>
                                    <td><strong>Σύνολο Αγορών</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalBought)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Σύνολο Πωλήσεων</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalSold)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Αποσβέσεις</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalAccDep)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Λογιστικό Αποτέλεσμα</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalProfit)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default ReportSoldFixedAssets;
